import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=0febef9c&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=0febef9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febef9c",
  null
  
)

export default component.exports